function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "fill"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.03.728h-1.824l-.428-.437a.955.955 0 0 0 -.686-.291h-3.184a.955.955 0 0 0 -.686.29l-.428.438h-1.824a.981.981 0 0 0 -.97.99v.52a.981.981 0 0 0 .97.99h9.06a.981.981 0 0 0 .97-.99v-.52a.981.981 0 0 0 -.97-.99m-.055 1.453h-8.95v-.407h1.792a.954.954 0 0 0 .686-.29l.428-.437h3.138l.428.437a.954.954 0 0 0 .686.29h1.792z",
  transform: "translate(0 -.001)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.127 74.2h-8.255a.869.869 0 0 0 -.859.876v8.2a2.027 2.027 0 0 0 2 2.044h5.966a2.027 2.027 0 0 0 2-2.044v-8.2a.869.869 0 0 0 -.859-.876m-.166 9.076a.99.99 0 0 1 -.979 1h-5.958a.99.99 0 0 1 -.979-1v-8.026h7.923z",
  transform: "translate(-9.5 -70.324)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m55.065 119.691a.518.518 0 0 0 .513-.523v-5.831a.513.513 0 1 0 -1.025 0v5.831a.518.518 0 0 0 .513.523",
  transform: "translate(-51.755 -106.915)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m96.795 119.691a.518.518 0 0 0 .513-.523v-5.831a.513.513 0 1 0 -1.025 0v5.831a.518.518 0 0 0 .513.523",
  transform: "translate(-91.346 -106.915)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m141.065 119.691a.518.518 0 0 0 .513-.523v-5.831a.513.513 0 1 0 -1.025 0v5.831a.518.518 0 0 0 .513.523",
  transform: "translate(-133.346 -106.915)"
}));

function SvgIconRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 11 15",
    width: 11,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon_remove.0e99353d.svg";
export { ForwardRef as ReactComponent };